import Kaia121 from "./kaia (0).webp";
import Kaia122 from "./kaia (7).webp";
import Kaia123 from "./kaia (8).webp";

const kaia12 = [Kaia121, Kaia122, Kaia123];

export default kaia12;
